import { CalendarDays, User } from 'lucide-react';
import { cn } from '../lib/utils';

/** Created date + creator (E251v1_GotUnits); matches icon + text rows in unit card headers. */
export function UnitCardCreatedByMeta({
    createdAt,
    createdByName,
    tone = 'default',
}: {
    createdAt: string;
    createdByName: string;
    tone?: 'default' | 'chalkboard';
}) {
    if (!createdAt && !createdByName) return null;
    const chalk = tone === 'chalkboard';
    return (
        <>
            {createdAt ? (
                <span className="flex items-center">
                    <CalendarDays size={14} className={cn('mr-1 shrink-0', chalk && 'text-zinc-400')} />
                    Created: {createdAt}
                </span>
            ) : null}
            {createdByName ? (
                <span className="flex items-center">
                    <User size={14} className={cn('mr-1 shrink-0', chalk && 'text-zinc-400')} />
                    By: {createdByName}
                </span>
            ) : null}
        </>
    );
}
